module.exports = __webpack_public_path__ + "static/media/spridning.07edcef4.mp3";